import React, { useState, useEffect } from 'react';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

import { useParams } from 'react-router-dom';
import { LoadingScreen } from '../components/common/LoadingScreen';
import { ErrorScreen } from '../components/common/ErrorScreen';


export const NewsDetailPage = () => {
  const { id } = useParams();
  const [newsArticle, setNewsArticle] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNewsArticle = async () => {
    try {
      const articleDocRef = doc(db, "news", id);
      const articleDocSnap = await getDoc(articleDocRef);

      if (articleDocSnap.exists()) {
        // Document data exists
        setNewsArticle(articleDocSnap.data());
      } else {
        // Document doesn't exist
        setError("Article not found");
      }
    } catch (err) {
      setError("Failed to fetch document: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewsArticle();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return <ErrorScreen errorMessage={error} />;
  }

  if (!newsArticle) {
    return <div>News not found!</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto p-4">
        {/* Image */}
        <img
          src={newsArticle.imageUrl}
          alt={newsArticle.title}
          className="w-full h-96 object-cover rounded-lg mb-6"
        />

        {/* Title */}
        <h1 className="text-4xl font-bold text-primary mb-4">{newsArticle.title}</h1>
        {/* Date */}
        {/* <p className="text-gray-500 text-sm mb-4">{newsArticle.date}</p> */}
        {/* Full Description */}
        <p className="text-gray-700 leading-relaxed">{newsArticle.description}</p>
      </div>
    </div>
  );
};
